export const MAX_RETRY_COUNT = 2;
export const RETRY_DELAY_MS = 500;
export const RETRY_JITTER_MS = 300;
export const MAX_CONCURRENT_RETRIES = 3;

export type RetryTask = {
    cancelled: boolean;
    run: () => void;
};

const failedImageUrls = new Set<string>();
const pendingRetryTasks: RetryTask[] = [];
let activeRetryCount = 0;

const flushRetryQueue = () => {
    while (activeRetryCount < MAX_CONCURRENT_RETRIES && pendingRetryTasks.length > 0) {
        const nextTask = pendingRetryTasks.shift();

        if (!nextTask || nextTask.cancelled) {
            continue;
        }

        activeRetryCount += 1;
        nextTask.run();
    }
};

const enqueueRetryTask = (task: RetryTask) => {
    pendingRetryTasks.push(task);
    flushRetryQueue();
};

const releaseRetrySlot = () => {
    if (activeRetryCount > 0) {
        activeRetryCount -= 1;
    }

    flushRetryQueue();
};

const hasFailedImageUrl = (url: string) => {
    return failedImageUrls.has(url);
};

const markImageUrlAsFailed = (url: string) => {
    failedImageUrls.add(url);
};

const buildRetryUrl = (url: string, retryCount: number): string => {
    try {
        const parsedUrl = new URL(url, window.location.origin);
        parsedUrl.searchParams.set('_imgRetry', String(retryCount));
        return parsedUrl.toString();
    } catch {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}_imgRetry=${retryCount}`;
    }
};

const getRetryDelay = (retryCount: number) => {
    return RETRY_DELAY_MS * retryCount + Math.floor(Math.random() * RETRY_JITTER_MS);
};

export { enqueueRetryTask, releaseRetrySlot, hasFailedImageUrl, markImageUrlAsFailed, buildRetryUrl, getRetryDelay };
